{
  "Common": {
    "Done": "Done",
    "Ok": "OK",
    "Save": "Save",
    "Update": "Update",
    "Exit": "Exit",
    "Close": "Close",
    "Dismiss": "Dismiss",
    "Cancel": "Cancel",
    "Write": "Write..",
    "Search": "Search",
    "Edit": "Edit",
    "Delete": "Delete",
    "Sorry": "Sorry",
    "Error": "Error",
    "Abort": "Abort",
    "Ignore": "Ignore",
    "SignOut": "Sign Out",
    "Submit": "Submit",
    "Add": "Add",
    "Navigate": "Navigate",
    "Send": "Send",
    "TypeHere": "Type here..",
    "No": "No",
    "Yes": "Yes",
    "Login": "Login",
    "Register": "Register",
    "Skip": "Skip",
    "Next": "Next",
    "Profile": "Profile",
    "AM": "AM",
    "PM": "PM",
    "Back": "Back",
    "Continue": "Continue",
    "PullToRefresh": "Pull To Refresh",
    "LoadRemainingData": "Load Remaining Data..",
    "Loading": "Loading..",
    "LoadingPosition": "Loading Your Position..",
    "NoMatch": "No Match",
    "UpdateAvailable": "An update is available. Update now?",
    "UpdateToNewestVersion": "Kindly update to the latest version in order to continue",
    "NoData": "No Data",
    "Userame": "Enter your phone number",
    "VerficationCode": "Enter verification code",
    "OldPassword": "Password",
    "NewPassword": "New Password",
    "Optional": "Optional",
    "PasswordChangedSuccessfully": "Password changed successfully",
    "YourPasswordResetSuccessfully": "Your password has been reset successfully",
    "NoticeSentSuccessfully": "Notice sent successfully",
    "RequestSubmittedSuccessfully": "Request submitted successfully",
    "ThisNationalityIsSelectedBefor": "This nationality is Sselected befor",
    "SAR": "SAR",
    "Previous": "Previous",
    "Change": "Change",
    "Pay": "Pay",
    "More": "More...",
    "Thanks": "Thank you",
    "Start": "Start",
    "Confirm": "Confirm",
    "PleaseSelectImageFile": "Please select an image file",
    "ExceededMaxSize": "Sorry, file size too large",
    "YouDidNotPickAFile": "You didn't pick a file",
    "EnterOTP": "Enter OTP",
    "ChooseAnOption": "Choose an option",
    "Home": "Home",
    "Accept":"Accept",
    "View":"View",
    "DoneSuccessfully": "Done Successfully",
    "ManPowerRequests": "Manpower",
    "RecruitmentRequests": "Recruitment",
    "Candidates": "Candidates",
    "Maharah": "Maharah",
    "ClientDefaultName": "Mobile Application System"
  },
  "Errors": {
    "Unknown": "An error occurred while processing your request, please try again.",
    "Offline": "Kindly check your internet connection.",
    "LocationPermissionDenied": "Kindly grant the app location permission in order to continue",
    "GeolocationPositionError": "Couldn't retrieve your coordinates. Ensure GPS is enabled.",
    "KindlyGrantCalendarPermission": "Kindly grant calendar permission",
    "LoginFailure": "Failed to login, please try again.",
    "ConnectionFailedPleaseTryAgain": "Connection failed please try again",
    "CantReachTheServer": "Can't reach the server, please try again",
    "PleaseFillAllFields": "Please fill all fields",
    "FailedToCopyBillNumberToClipboard": "Failed to copy bill number to clipboard",
    "PleaseEnterValidEmail": "Please enter valid email",
    "SorryNoClipboardSupport": "Sorry, no clipboard support found",
    "PleaseEnterOTP": "Please enter OTP",
    "required":"This field is required",
    "min":"Please enter a number greater than zero"
  },
  "ServerErrors": {
    "LocationNotSupported": "We apologize, our services do not cover your area currently and we look forward to that in the future.",
    "UnhandledServerError": "Server error occurred, please try again.",
    "InvalidModel": "Invalid data, please check",
    "ResourceNotFound": "Server error occurred, please try again.",
    "PasswordMismatch": "Password incorrect",
    "InvalidUserName": "Username incorrect",
    "InvalidEmail": "Email incorrect",
    "DuplicateUserName": "This username has already been used, please choose another name",
    "DuplicateEmail": "This email address has already been used, please enter another email address",
    "PasswordTooShort": "Password entered is too short",
    "PasswordRequiresNonAlphanumeric": "Password must contain special characters (e.g., !@#$%)",
    "PasswordRequiresDigit": "Password must contain numbers",
    "PasswordRequiresLower": "Password must contain lowercase letters (e.g., abcde..)",
    "PasswordRequiresUpper": "Password must contain uppercase letters (e.g., ABCDE..)",
    "invalid_grant": "Error in phone number or password",
    "UserNotRegistered": "User not registered",
    "UserAlreadyRegistered": "You are already registered in the system, please log in",
    "UserIsBlocked": "User is blocked",
    "UserNameIsRequired": "Please enter username",
    "PasswordIsRequired": "Please enter password",
    "UserHasNoPhoneNumber": "User does not have a phone number",
    "TokenIsRequired": "Please enter the code sent to your phone",
    "NewPasswordIsRequired": "Please enter the new password",
    "PhoneNumberIsRequired": "Please enter your phone number",
    "InvalidToken": "Invalid verification code",
    "FillAllFields": "Please fill all fields"
  },
  "DomainCommon": {
    "Registration": "Registration",
    "Details": "Details",
    "Result": "Result",
    "Payment": "Payment",
    "Status": "Status",
    "Age": "Age",
    "SAR": "SAR",
    "Request": "Request",
    "Summary": "Summary",
    "Options": "Options",
    "SubmittingRequest": "Submitting request..",
    "Attention": "Attention",
    "RequestProcessCompletedSuccessfully": "Request process completed successfully",
    "Discount": "Discount",
    "PleaseLoginToContinue": "Please login in order to continue",
    "Riyal": "Riyal",
    "DearCustomer": "Dear Customer",
    "Confirm": "Confirm",
    "Reject": "Reject",
    "ContractNumber": "Contract Number",
    "AddNew":"Add",
    "WriteHere":"Write Here"
  },
  "Languages": {
    "0": "English",
    "1": "عربي"
  },
  "PriceOffer": {
    "Workflow": {
      "CandidateRegistration": "Candidate Registration",
      "CandidateSelestion": "Candidate Selection",
      "Complete": "Complete"
    }
  },
  "Recruitment": {
    "RecruitmentCount": "Recruitment Requests Count",
    "DoneCount": "Done Count",
    "PendingCount": "Pending Count",
    "CanceledCount": "Canceled Count",
    "RegisteredCount": "Registered Count"
  },
  "Agency": {
    "AgencyCount": "Agency Requests Count",
    "DoneCount": "Done Count",
    "PendingCount": "Pending Count",
    "CanceledCount": "Canceled Count"
  },
  "Footer": {
    "UnifiedNumber": "Unified Number 920011151",
    "FAQ": "FAQ",
    "PrivacyPolicy": "Privacy Policy",
    "TermsOfUse": "Terms of Use",
    "Copyright": "Maharah Human Resources Company © 2023"
  },
  "ManPower": {
    "PageTitle": "ManPower Requests",
    "Breadcrumb": "ManPower Requests",
    "RequestId": "Request ID",
    "CompanyName": "Company Name",
    "RequiredNumber": "Required Number",
    "Status": "Status"
  },
  "ManPowerDetails": {
    "PageTitle": "Request Details",
    "Breadcrumb": "ManPower",
    "RequestInfo": "Request Information",
    "CompanyInfo": "Company Information",
    "CandidatesList": "Candidates List",
    "RequestId": "Request ID",
    "ProcedureId": "Procedure ID",
    "CompanyId": "Company ID",
    "StateId": "State ID",
    "CompanyName": "Company Name",
    "OrderDate": "Order Date",
    "CountNumber": "Count Number",
    "OrderDetailsNumber": "Order Details Number",
    "RequiredNumber": "Required Number",
    "AuthorizedNumber": "Authorized Number",
    "Status": "Status",
    "InProgress": "In Progress",
    "Completed": "Completed",
    "Pending": "Pending",
    "CandidateName": "Candidate Name",
    "PassportNumber": "Passport Number",
    "Occupation": "Occupation",
    "ContactNumber": "Contact Number",
    "Actions": "Actions",
    "RequestSpecifications": "Request Specifications",
    "AddNewCandidate": "Add New Candidate",
    "DownloadFile": "Download File",
    "BulkUpload": "Bulk Upload",
    "CommentsAndAttachments": "Comments & Attachments",
    "Comments": "Comments",
    "Attachments": "Attachments",
    "WriteComment": "Write a comment...",
    "AddComment": "Add Comment",
    "ChooseFile": "Choose File",
    "Upload": "Upload",
    "NoComments": "No comments yet",
    "NoAttachments": "No attachments yet",
    "DeleteAttachment": "Delete",
    "Withdrawn": "Withdrawn",
    "FailedMedicalTest": "Failed Medical Test",
    "WithdrawnConfirmTitle": "Confirmation",
    "WithdrawnConfirmMessage": "Are you sure you want to mark this candidate as withdrawn?",
    "FailedMedicalTestConfirmTitle": "Confirmation",
    "FailedMedicalTestConfirmMessage": "Are you sure you want to mark this candidate as failed medical test?"
  },
  "RecruitmentPage": {
    "PageTitle": "Recruitment Requests",
    "Breadcrumb": "Recruitment Requests",
    "DetailsPageTitle": "Request Details",
    "DetailsBreadcrumb": "Request Details",
    "RequestId": "Request ID",
    "CompanyName": "Company Name",
    "Candidate": "Candidate",
    "Status": "Status",
    "Notes": "Notes",
    "RequestInfo": "Request Information",
    "OrderDate": "Order Date",
    "Name": "Name",
    "PassportNumber": "Passport Number",
    "Occupation": "Occupation",
    "Nationality": "Nationality",
    "VisaNumber": "Visa Number",
    "BasicSalary": "Net Salary",
    "HousingAllowance": "Housing Allowance",
    "TransportationAllowance": "Transportation Allowance",
    "LivingAllowance": "Living Allowance",
    "OtherAllowance": "Other Allowance",
    "VacationDays": "Vacation Days",
    "IssuingTicket": "Respnsible For Issuing Ticket",
    "RequestType": "Request Type",
    "MedicalTestPass": "Medical Test Pass",
     "StampingNumber": "Stamping Number",
    "StampingDate": "Stamping Date",
    "Form":{
      "MedicalTest": "Medical Test",
     "StampingNumber": "Stamping Number",
    "StampingDate": "Stamping Date",
    "CityFromOutKSA": "Departure From",
    "CityToInKSA": "Arrival Destination",
    "FlightNo": "Flight Number",
    "TravelDate": "Travel Date",
    "ArrivalDate": "Arrival Date",
    "Ticket": "Ticket"
    },
     "Workflow": {
      "Professional":{
      "Editing": "Editing",
      "DocumentsUploading": "Documents Uploading",
      "LicensingTeam": "Licensing Team",
      "DocumentsAttestation": "Documents Attestation",
      "MedicalTest": "Medical Test",
      "VisaStamping": "Visa Stamping",
      "ExitPermitClearance": "Exit Permit Clearance",
      "Ticket": "Ticket",
      "Compeleted": "Compeleted",
      "Cancelled": "Cancelled"
    }
  }
  },
  "CandidatesPage": {
    "PageTitle": "Candidate Requests",
    "Breadcrumb": "Candidates",
    "RejectedCount": "Rejected Candidates Count",
    "AcceptedCount": "Accepted Candidates Count",
    "TotalCount": "Total Candidates Count",
    "RequestId": "Request ID",
    "Name": "Name",
    "PassportNumber": "Passport Number",
    "OccupationInPassport": "Occupation in Passport",
    "Status": "Status",
    "DateOfBirth": "Date of Birth",
    "ContactNumber": "Contact Number",
    "Skills": "Skills",
    "AddNewCandidate": "Add New Candidate",
    "CandidateDetails": "Candidate Details",
    "AddImage": "Add Candidate Image",
    "FirstName": "First Name",
    "MiddleName": "Middle Name",
    "LastName": "Last Name",
    "Email": "Email",
    "Specialization": "Specialization",
    "YearsOfExperience": "Years of Experience",
    "FirstNameRequired": "First Name is required",
    "MiddleNameRequired": "Middle Name is required",
    "LastNameRequired": "Last Name is required",
    "EmailInvalid": "Email is invalid",
    "DateOfBirthRequired": "Date of Birth is required",
    "PassportNumberRequired": "Passport Number is required",
    "OccupationInPassportRequired": "Occupation in Passport is required",
    "LanguageValidation": "English letters are only allowed",
    "SkillsSection": "Skills",
    "LanguagesSection": "Languages",
    "AddSkills": "Add Skill",
    "AddLanguages": "Add Language",
    "EnterSkill": "Enter skill",
    "NoSkillsAdded": "No skills added",
    "SelectLanguage": "Select Language",
    "AttachmentsSection": "Attachments",
    "AddAttachments": "Add Attachment",
    "File": "File",
    "FileType": "File Type"
  },
  "Notifications": {
    "Title": "Notifications",
    "MarkAllAsRead": "Mark all as read",
    "NoNotifications": "No notifications",
    "JustNow": "Just now",
    "MinutesAgo": "minutes ago",
    "HoursAgo": "hours ago",
    "DaysAgo": "days ago",
    "RecruitmentTitle": "Recruitment Request",
    "ManPowerTitle": "Manpower Request",
    "NewRequestMessage": "A new manpower request #1234 has been submitted and is awaiting your review.",
    "RequestApprovedMessage": "Your recruitment request #5678 has been approved successfully.",
    "CandidateAddedTitle": "Candidate Added",
    "CandidateAddedMessage": "A new candidate has been added to manpower request #1234.",
    "DocumentUploadedTitle": "Document Uploaded",
    "DocumentUploadedMessage": "Documents for candidate Ahmed Ali have been uploaded successfully.",
    "StatusChangedTitle": "Status Changed",
    "StatusChangedMessage": "The status of recruitment request #9012 has been changed to In Progress."
  }
}
